import * as CoreFns from '../utilities/CoreFns';
import * as StyleFunctions from '../utilities/StyleFunctions';
import TableWrapRowsBoot from '../StockItems/TableWrapRowsBoot';
import NormalIcon from '../StockItems/NormalIcon';

function App(props) {

  var origCurrentScreenStyle = props.origCurrentScreenStyle;
  var currentList = props.currentList;
  var stylePath = props.stylePath;
  var organicChanges = props.organicChanges;
  var anItem = props.anItem;
  var userNos = props.userNos;
  var currentScreenStyle = props.currentScreenStyle;
  var origStylePath = props.origStylePath;

  var currentTe = '';
   if (origCurrentScreenStyle.te){
    currentTe = origCurrentScreenStyle.te.v;
   }

  var st = currentList.st;
  var stKeys = Object.keys(st);

  function clickExistingStyle(anStKey){
    return function(e){
      var pp = [{t:'w',w:stylePath.concat(['te']),n:{t:'sy',v:anStKey}}];
      organicChanges(pp);
    }
  }

  function clickDelete(anStKey){
    return function(e){
      var pp = [{t:'r',w:['st'],i:anStKey}];
      if (currentTe === anStKey){
        pp.push({t:'r',w:origStylePath,i:'te'})
      }
      organicChanges(pp);
    }
  }

  var optionRows = stKeys.filter((anStKey, index)=>{
    var thisST = st[anStKey];
    return thisST.t === anItem.i
  }).map((anStKey, index)=>{
    var thisST = st[anStKey];
    var outline = 'outline-';
    if (currentTe === anStKey){
      outline = '';
    }
    return <tr key={index}><td><div className={'btn btn-'+outline+'primary'} onClick={clickExistingStyle(anStKey)}>{StyleFunctions.shortenName(thisST.n)}</div></td><td><center><NormalIcon icon='fe:trash' title='Delete' height='30px' onClick = {clickDelete(anStKey)} /></center></td></tr>
  })

//
  var saveRemovePiece;
  if (currentScreenStyle.te && st[currentScreenStyle.te.v]){
    function clickRemove(e){
      var pp1 = [{t:'r',w:origStylePath,i:'te'}]
      organicChanges(pp1);
    }
    saveRemovePiece = <button className='btn btn-secondary' onClick={clickRemove}>Remove Peg</button>
//
  }else{
    function clickSave(){
      var p = window.prompt('What would you like to call this style?','');
      if (p !== undefined && p !== null){
        p = p.trim();
        if (!p){
          window.alert('Empty style names are not allowed');
          return;
        }

        var pathDown = ['st'];
        var uuid = CoreFns.uuidScoped(userNos, currentList, pathDown, []);  
        var s = JSON.parse(JSON.stringify(currentScreenStyle));
        var toRemove = StyleFunctions.toIgnoreFromCommonSet();
        toRemove.forEach((aR, index)=>{
          delete s[aR];
        })
        var n = {n:p, t:anItem.i, s};
        var pp = [{t:'w',w:['st', uuid],n}, {t:'w',w:origStylePath.concat(['te']),n:{t:'sy',v:uuid}}];
        organicChanges(pp);
      }
    }
    saveRemovePiece = <button className='btn btn-secondary' onClick={clickSave}>Save Style</button>
  }
//
  var tableRows;
  if (optionRows.length > 0){
    tableRows = <TableWrapRowsBoot rows={optionRows} headerCells={['Select', '']}/>
  }


//      
  return (<td>
      {tableRows}
      <center>
        {saveRemovePiece}
      </center>
    </td>)
//
}



//
export default App;
